import React from "react";
import Moment from "moment";
import _ from 'lodash';
import Button from "@material-ui/core/Button";
import Card from "@material-ui/core/Card";
import CircularProgress from "@material-ui/core/CircularProgress";
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";
import DateFnsUtils from "@date-io/moment";
import { MuiPickersUtilsProvider, KeyboardDateTimePicker } from "@material-ui/pickers";

export default class PromotionCreate extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: true,
      products: [],
      applePricePoints: [],

      name: "",
      productId: "",
      selectedProductPrice: null,
      applePricePointId: "",
      discountAmount: 0,
      startDate: Moment().startOf('day'),
      endDate: Moment().endOf('day'),
    };
  }

  componentDidMount() {
    this.fetchProducts();
  }

  fetchProducts = () => {
    this.props.fetchApi("get", "/products")
      .then((response) => {
        this.setState({
          products: response.data.products,
          loading: false,
        });
      })
      .catch(() => {
        this.props.showSnackbar("Erro ao carregar produtos. Tente novamente.");
        this.setState({ loading: false });
      });
  };

  fetchApplePricePoints = (sku) => {
    if (!sku) return;
    this.setState({ loading: true, applePricePoints: [] });
    this.props.fetchApi("get", `/apple-price-points/${sku}`)
      .then(response => {
        this.setState({
          applePricePoints: response.data.data,
          loading: false,
        });
      })
      .catch(() => {
        this.props.showSnackbar('Erro ao carregar preços da Apple. Tente novamente.');
        this.setState({ loading: false });
      });
  }

  handleProductChange = (event) => {
    const productId = event.target.value;
    const selectedProduct = this.state.products.find(p => p.id === productId);

    if (selectedProduct) {
      const priceInBRL = selectedProduct.prices.find((price) => price.currency === "BRL");
      const currentPrice = priceInBRL ? priceInBRL.price : null;
      console.log(currentPrice);

      this.setState({
        productId: productId,
        selectedProductPrice: currentPrice,
        applePricePointId: "",
        discountAmount: 0,
      });

      // Find the price points for the selected product's SKU
      this.fetchApplePricePoints(selectedProduct.storeId);
    }
  };

  handleApplePricePointChange = (event) => {
    const pricePointId = event.target.value;
    const selectedPricePoint = this.state.applePricePoints.find(p => p.id === pricePointId);

    if (selectedPricePoint && this.state.selectedProductPrice) {
      const promotionalPrice = parseFloat(selectedPricePoint.attributes.customerPrice);
      const originalPrice = parseFloat(this.state.selectedProductPrice);
      const discount = originalPrice > promotionalPrice ? originalPrice - promotionalPrice : 0;

      this.setState({
        applePricePointId: pricePointId,
        discountAmount: discount,
      });
    }
  }


  createPromotion = () => {
    const { name, discountAmount, startDate, endDate, productId, applePricePointId } = this.state;

    // Validação simples no frontend
    if (!name || !startDate || !endDate || !productId) {
      this.props.showSnackbar("Todos os campos são obrigatórios.");
      return;
    }

    this.setState({ loading: true });

    this.props
      .fetchApi("post", `/promotions`, {
        data: {
          type: "promotion",
          attributes: {
            name,
            discountAmount,
            startDate: Moment(startDate).toISOString(),
            endDate: Moment(endDate).toISOString(),
            applePromotionPricePointId: applePricePointId,
          },
          relationships: {
            product: {
              data: {
                type: "product",
                id: productId,
              },
            },
          },
        },
      })
      .then(() => {
        this.props.showSnackbar("Promoção agendada com sucesso.");
        setTimeout(() => this.props.popRoute(), 2000);
      })
      .catch((err) => {
        const errorMsg = _.get(
          err,
          "response.data.errors[0].detail",
          "Erro ao agendar promoção. Tente novamente."
        );
        this.props.showSnackbar(errorMsg);
        this.setState({ loading: false });
      });
  };

  onChangeField = (field, value) => {
    this.setState({ [field]: value });
  };

  render() {
    const { loading, name, discountAmount, startDate, endDate, productId, products, applePricePoints, applePricePointId } =
      this.state;

    if (loading) {
      return <CircularProgress style={{ margin: "2rem" }} />;
    }

    return (
      <div>
        <br /><br />
        <Card style={{ padding: "1rem" }}>
          <Typography color="textSecondary" gutterBottom>
            Agendar Nova Promoção
          </Typography>
          <br />
          <form>
            <TextField
              label="Nome da Promoção"
              fullWidth
              value={name}
              onChange={(event) =>
                this.onChangeField("name", event.target.value)
              }
              style={{ marginBottom: "1rem" }}
            />

            <FormControl fullWidth style={{ marginBottom: "1rem" }}>
              <InputLabel>Produto</InputLabel>
              <Select value={productId} onChange={this.handleProductChange}>
                {products.map(product => (
                  <MenuItem key={product.id} value={product.id}>{product.name}</MenuItem>
                ))}
              </Select>
            </FormControl>

            <FormControl fullWidth style={{ marginBottom: "1rem" }} disabled={!productId}>
              <InputLabel>Preço Promocional (Apple)</InputLabel>
              <Select value={applePricePointId} onChange={this.handleApplePricePointChange}>
                {applePricePoints.map(point => (
                  <MenuItem key={point.id} value={point.id}>
                    R$ {point.attributes.customerPrice}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            <TextField
              label="Valor do Desconto (calculado automaticamente)"
              fullWidth type="number"
              value={discountAmount.toFixed(2)}
              disabled // O campo agora é desabilitado
              style={{ marginBottom: "1rem" }}
            />

            <MuiPickersUtilsProvider utils={DateFnsUtils}>
              <div style={{ display: "flex", gap: "1rem", marginBottom: "1rem" }}>
                <KeyboardDateTimePicker
                  label="Data e Hora de Início"
                  format="DD/MM/YYYY HH:mm"
                  value={startDate}
                  onChange={(date) => this.onChangeField("startDate", date)}
                  style={{ flex: 1 }}
                />
                <KeyboardDateTimePicker
                  label="Data e Hora de Término"
                  format="DD/MM/YYYY HH:mm"
                  value={endDate}
                  onChange={(date) => this.onChangeField("endDate", date)}
                  style={{ flex: 1 }}
                />
              </div>
            </MuiPickersUtilsProvider>

            <Button variant="contained" color="primary" onClick={this.createPromotion}>
              Agendar Promoção
            </Button>
          </form>
        </Card>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/PromotionCreate.js